import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { GoogleOAuthProvider } from "@react-oauth/google";
import reportWebVitals from "./reportWebVitals";
import { SnackbarProvider } from "notistack";
import { Constants } from "./utils/Constants";
import { clarity } from "react-microsoft-clarity";
const googleKey = Constants.REACT_APP_GOOGLE_CLIENT_ID + "";
// Clarity
const projectId = Constants.CLARITY_PROJECT_ID;
if (projectId)
    clarity.init(projectId);
ReactDOM.render(React.createElement(SnackbarProvider, null,
    React.createElement(GoogleOAuthProvider, { clientId: googleKey },
        React.createElement(React.StrictMode, null,
            React.createElement(App, null)))), document.getElementById("root"));
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
